import { ChatbotAttachmentProvider, ChatbotFloatButton } from 'features/chatbot'
import { KnowledgeDocumentDataProvider } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { KnowledgeDocumentUXProvider } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { TimeSeriesLinkProvider } from 'features/knowledgeDocumentViewer/contexts/TimeSeriesLinkContext'
import { PermissionsGate, useGeckoPermissions } from 'features/permissions'
import { useMemo } from 'react'
import {
  DocumentViewerUrlPaths,
  PERMISSION_CANTILEVER_DELPHI_VIEWER,
  PERMISSION_CANTILEVER_DOCUMENT_OCR_ADMIN,
  PERMISSION_CANTILEVER_DOCUMENT_OCR_EDITOR,
} from 'types'

import { KnowledgeDocumentTools } from './components/KnowledgeDocumentTools'

export type KnowledgeDocumentViewerProps = {
  siteID: string
  organizationID: string
  viewOnly?: boolean
  basePath: DocumentViewerUrlPaths
}

export function KnowledgeDocumentViewer({
  siteID,
  organizationID,
  viewOnly = true,
  basePath,
}: KnowledgeDocumentViewerProps) {
  const { hasPermissions } = useGeckoPermissions()
  const isEditor = hasPermissions([
    PERMISSION_CANTILEVER_DOCUMENT_OCR_EDITOR,
    PERMISSION_CANTILEVER_DOCUMENT_OCR_ADMIN,
  ])

  const forceViewOnly = useMemo(() => {
    return !isEditor ? true : viewOnly
  }, [isEditor, viewOnly])

  return (
    <ChatbotAttachmentProvider>
      <KnowledgeDocumentUXProvider basePath={basePath} viewOnly={forceViewOnly}>
        <KnowledgeDocumentDataProvider siteID={siteID} orgID={organizationID}>
          <TimeSeriesLinkProvider siteID={siteID}>
            <KnowledgeDocumentTools scale={2} />
          </TimeSeriesLinkProvider>
        </KnowledgeDocumentDataProvider>
      </KnowledgeDocumentUXProvider>
      <PermissionsGate requires={[PERMISSION_CANTILEVER_DELPHI_VIEWER]}>
        <ChatbotFloatButton />
      </PermissionsGate>
    </ChatbotAttachmentProvider>
  )
}
